import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "draft-preview" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger py-2 mb-3"
}
const _hoisted_3 = { class: "mb-0 mt-2 small" }
const _hoisted_4 = {
  key: 1,
  class: "alert alert-warning py-2 mb-3 small"
}
const _hoisted_5 = { class: "d-flex align-items-end gap-2 flex-wrap mb-3" }
const _hoisted_6 = { class: "nav nav-tabs flex-grow-1 mb-0" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 2,
  class: "alert alert-warning py-1 px-2 small"
}
const _hoisted_9 = { class: "d-flex align-items-center gap-3 mb-2 flex-wrap" }
const _hoisted_10 = {
  class: "btn-group btn-group-sm",
  role: "group"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "badge bg-dark ms-1" }
const _hoisted_13 = { class: "text-muted small ms-auto" }
const _hoisted_14 = { class: "table-responsive draft-scroll" }
const _hoisted_15 = { class: "table table-sm table-hover align-middle mb-0" }
const _hoisted_16 = { class: "text-muted small" }
const _hoisted_17 = {
  key: 0,
  class: "badge bg-warning text-dark ms-1"
}
const _hoisted_18 = {
  key: 1,
  class: "badge bg-info text-dark ms-1"
}
const _hoisted_19 = ["title"]
const _hoisted_20 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_21 = { class: "small text-muted" }
const _hoisted_22 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DraftTreeView = _resolveComponent("DraftTreeView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.draft.unplaceable?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("strong", null, [
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.draft.unplaceable.length) + " sin colocar", 1)
          ]),
          _cache[3] || (_cache[3] = _createTextVNode(" — el driver los reporta, nunca los adivina. Revisa antes de aplicar. ", -1)),
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.unplaceable, (u) => {
              return (_openBlock(), _createElementBlock("li", {
                key: u.username
              }, [
                _createElementVNode("code", null, _toDisplayString(u.username), 1),
                _createTextVNode(" — " + _toDisplayString(u.reason), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.draft.warnings?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.warnings, (w, i) => {
            return (_openBlock(), _createElementBlock("div", { key: i }, [
              _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-triangle-exclamation" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(w), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
          return (_openBlock(), _createElementBlock("li", {
            key: tab.key,
            class: "nav-item"
          }, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["nav-link", { active: _ctx.view === tab.key }]),
              onClick: ($event: any) => (_ctx.view = tab.key)
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["fas", tab.icon])
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(tab.label), 1)
            ], 10, _hoisted_7)
          ]))
        }), 128))
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-outline-primary mb-1",
        title: "Descarga los dos árboles completos en un fichero HTML que se puede mandar y abrir en cualquier navegador",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exportHtml && _ctx.exportHtml(...args)))
      }, [...(_cache[5] || (_cache[5] = [
        _createElementVNode("i", { class: "fas fa-file-arrow-down" }, null, -1),
        _createTextVNode(" Exportar para compartir ", -1)
      ]))])
    ]),
    (_ctx.exportError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-triangle-exclamation" }, null, -1)),
          _createTextVNode(" No se pudo generar el fichero: " + _toDisplayString(_ctx.exportError), 1)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_DraftTreeView, { forest: _ctx.binaryForest }, null, 8, ["forest"]), [
      [_vShow, _ctx.view === 'binary']
    ]),
    _withDirectives(_createVNode(_component_DraftTreeView, { forest: _ctx.unilevelForest }, null, 8, ["forest"]), [
      [_vShow, _ctx.view === 'unilevel']
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (f) => {
            return (_openBlock(), _createElementBlock("button", {
              key: f.key,
              type: "button",
              class: _normalizeClass(["btn", _ctx.filter === f.key ? 'btn-primary' : 'btn-outline-secondary']),
              onClick: ($event: any) => (_ctx.filter = f.key)
            }, [
              _createTextVNode(_toDisplayString(f.label) + " ", 1),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.countOf(f.key)), 1)
            ], 10, _hoisted_11))
          }), 128))
        ]),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
          type: "search",
          class: "form-control form-control-sm w-auto",
          placeholder: "buscar usuario / padre…"
        }, null, 512), [
          [_vModelText, _ctx.search]
        ]),
        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.rows.length) + " de " + _toDisplayString(_ctx.draft.nodes.length) + " nodos ", 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("table", _hoisted_15, [
          _cache[8] || (_cache[8] = _createElementVNode("thead", { class: "table-light sticky-top" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { style: {"width":"3rem"} }, "#"),
              _createElementVNode("th", null, "Usuario"),
              _createElementVNode("th", null, "Paquete"),
              _createElementVNode("th", null, "Cuelga de (binario)"),
              _createElementVNode("th", null, "Lado"),
              _createElementVNode("th", null, "Cuelga de (unilevel)"),
              _createElementVNode("th", null, "Enroller"),
              _createElementVNode("th", null, "Rango")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (node) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: node.username,
                class: _normalizeClass({
                'table-warning': node.isAnchor,
                'table-info': node.isGenesis && !node.isAnchor,
              })
              }, [
                _createElementVNode("td", _hoisted_16, _toDisplayString(node.order), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("strong", null, _toDisplayString(node.displayUsername), 1),
                  (node.isAnchor)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "ancla"))
                    : _createCommentVNode("", true),
                  (node.isGenesis)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, "génesis"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", _ctx.tierClass(node.tier)])
                  }, _toDisplayString(_ctx.packageLabel(node.package)), 3),
                  (node.tier !== node.counterTier)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "text-muted small ms-1",
                        title: 
                    'nivel interno del motor: ' +
                    node.tier +
                    ' — cuenta como ' +
                    node.counterTier +
                    ' en los contadores de directos'
                  
                      }, "cuenta como " + _toDisplayString(node.counterTier), 9, _hoisted_19))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, [
                  (node.binaryParentPK)
                    ? (_openBlock(), _createElementBlock("code", {
                        key: 0,
                        class: _normalizeClass({ 'text-info': node.binaryParentPK === _ctx.draft.root })
                      }, _toDisplayString(node.binaryParentPK), 3))
                    : (_openBlock(), _createElementBlock("span", _hoisted_20, "— fuera del binario"))
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", 
                    node.binarySide === 'left' ? 'bg-primary' : 'bg-success'
                  ])
                  }, _toDisplayString(node.binarySide), 3)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("code", null, _toDisplayString(node.unilevelParentPK), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("code", null, _toDisplayString(node.enroller), 1)
                ]),
                _createElementVNode("td", _hoisted_21, _toDisplayString(node.rankId || "—"), 1)
              ], 2))
            }), 128)),
            (_ctx.rows.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("td", {
                    colspan: "8",
                    class: "text-center text-muted py-3"
                  }, " Nada que mostrar con este filtro. ", -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.view === 'table']
    ])
  ]))
}